var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.4614H1.4V3.53792H3.2165C3.2165 3.53792 3.6988 2.84864 4.7355 1.99936H0.7C0.514348 1.99936 0.336301 2.08041 0.205025 2.22468C0.0737498 2.36894 0 2.56461 0 2.76864L0 11.2307C0 11.4347 0.0737498 11.6304 0.205025 11.7747C0.336301 11.919 0.514348 12 0.7 12H11.2C11.3857 12 11.5637 11.919 11.695 11.7747C11.8263 11.6304 11.9 11.4347 11.9 11.2307V8.349L10.5 9.61446V10.4614ZM9.3527 5.11494V7.84666L14 3.84563L9.3527 0V2.40862C3.71 2.40862 3.71 8.53824 3.71 8.53824C5.3074 5.65498 6.2902 5.11494 9.3527 5.11494Z",
    fill: "#969698"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.7d75169207567ce4c3e6f0c45bdaf7ec.svg";
export { ForwardRef as ReactComponent };